import request from '@/utils/request'

// 获取所有发布的临展活动
export function getTemporaryList(params) {
  return request({
    url: '/api/activity/temporary/list',
    method: 'get',
    params
  });
}
export function getTemporaryInfo(id) {
  return request({
    url: '/api/activity/temporary/info/' + id,
    method: 'get',
  });
}
// 确认订单
export function confirmOrder(data) {
  return request({
    url: '/api/activity/temporary/confirmOrder',
    method: 'post',
    data
  });
}
// 提交订单
export function submitOrder(data) {
  return request({
    url: '/api/activity/temporary/submitOrder',
    method: 'post',
    data
  });
}
// 获取已预约的临展列表
export function getmytemporary(params) {
  return request({
    url: '/api/activity/temporary/getMyOrderList',
    method: 'get',
    params
  });
}
// 获取已预约的临展信息
export function getmytemporaryInfo(params) {
  return request({
    url: '/api/activity/temporary/getMyOrderDetail',
    method: 'get',
    params
  });
}
// 退订单个临展预约票
export function refundTemporaryOrder(params) {
  return request({
    url: '/api/activity/temporary/refund',
    method: 'get',
    params
  });
}
// 退订全部临展预约票
export function refundAll(params) {
  return request({
    url: '/api/activity/temporary/refundAll',
    method: 'get',
    params
  });
}
// 退订单个临展预约票
export function getCloseDateList() {
  return request({
    url: '/api/getCloseDateList',
    method: 'get',
  });
}

//特色展厅列表查询
export function getExhibitionAreaList(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaList',
    method: 'get',
    params
  });
}

//特色展厅详情
export function getExhibitionAreaDetail(params) {
  return request({
    url: '/api/exhibitionAreaAppointment/getExhibitionAreaDetail',
    method: 'get',
    params
  });
}
//常设展区列表查询查询
export function findArea(params) {
  return request({
    url: '/api/exhibitionPermanent/exhibitionPermanent/list',
    method: 'get',
    params
  });
}
//常设展项列表查询
export function findExhibition(params) {
  return request({
    url: '/api/exhibition/exhibitionNormal/list',
    method: 'get',
    params
  });
}
//常设展项详情
export function getPermanentInfo(params) {
  return request({
    url: '/api/exhibitionPermanent/exhibitionPermanent/info',
    method: 'get',
    params
  });
}
//临时展区列表查询查询
export function findtemporaryArea(params) {
  return request({
    url: '/api/exhibitiontemp/exhibitiontemporary/list',
    method: 'get',
    params
  });
}
//临时展区详情
export function gettemporaryInfo(params) {
  return request({
    url: '/api/exhibitiontemp/exhibitiontemporary/info',
    method: 'get',
    params
  });
}
//展览点赞
export function saveLiked(params) {
  return request({
    url: '/api/exhibition/exhibitiontemppermliked/save',
    method: 'get',
    params
  });
}
// 取消展览点赞
export function deletetLiked(params) {
  return request({
    url: '/api/exhibition/exhibitiontemppermliked/delete',
    method: 'get',
    params
  });
}
// 临时展览分享
export function temporaryshared(params) {
  return request({
    url: '/api/exhibitiontemp/exhibitiontemporary/shared',
    method: 'get',
    params
  });
}
// 常设展览分享
export function permanentshared(params) {
  return request({
    url: '/api/exhibitionPermanent/exhibitionPermanent/shared',
    method: 'get',
    params
  });
}
// 点赞展览
export function exhibitionliked(params) {
  return request({
    url: '/api/exhibition/exhibitiontemppermliked/list',
    method: 'get',
    params
  });
}
// 常设展览展品
export function getCommonlist(params) {
  return request({
    url: '/api/exhibitionpermanent/exhibitionpermanenexhibition/list',
    method: 'get',
    params
  });
}
// 楼层列表
export function getfloor(params) {
  return request({
    url: '/api/floor/all',
    method: 'get',
    params
  });
}
// 临展退票
export function deletetemporary(params) {
  return request({
    url: '/api/activity/temporary/subscribe/temporary/delete',
    method: 'delete',
    params
  });
}
//观众的个人信息
export function getMe(params) {
  return request({
    url: '/api/me',
    method: 'get',
    params
  });
}
//随行人员列表
export function getEntourageList(params) {
  return request({
    url: '/api/visitorappointmenttogether/visitorappointmentogether/list',
    method: 'get',
    params
  });
}

// 完善个人信息
export function completeInfo(data) {
  return request({
    url: '/api/visitor/completeVisitorInfo',
    method: 'post',
    data
  });
}

// 随行人员信息更新
export function visitorappointmentogetherUpdate(data) {
  return request({
    url: '/api/visitorappointmenttogether/visitorappointmentogether/update',
    method: 'post',
    data
  });
}
// 随行人员信息增加
export function visitorappointmentogetherSave(data) {
  return request({
    url: '/api/visitorappointmenttogether/visitorappointmentogether/save',
    method: 'post',
    data
  });
}
// 随行人员信息删除
export function visitorappointmentogetherDelete(data) {
  return request({
    url: '/api/visitorappointmenttogether/visitorappointmentogether/delete',
    method: 'post',
    data
  });
}




// WEBPACK FOOTER //
// ./src/api/navigation/index.js